import { render, staticRenderFns } from "./ItemAdd.vue?vue&type=template&id=4a0ab829&scoped=true"
import script from "./ItemAdd.vue?vue&type=script&lang=js"
export * from "./ItemAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ab829",
  null
  
)

export default component.exports